module.exports = __webpack_public_path__ + "img/2026-pass.dd98394a.svg";